import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { SHOW_INFO, CONTACT_INFO } from '../data/showData';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#0a0a0a]">
      <div className="container-custom max-w-4xl">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-gray-400 hover:text-[#FFD700] transition-colors mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla home
        </Link>

        <div className="bg-[#121212] rounded-2xl border border-white/5 p-6 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <Shield className="w-8 h-8 text-[#FFD700]" />
            <h1 className="text-3xl md:text-4xl font-bold text-white">Privacy Policy</h1>
          </div>

          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <p className="text-gray-400 text-sm">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Titolare del trattamento</h2>
              <p>
                Il titolare del trattamento dei dati personali è {SHOW_INFO.organization}, 
                con sede in {SHOW_INFO.venue.city}. Per qualsiasi informazione relativa al trattamento 
                dei tuoi dati personali, puoi contattarci all'indirizzo email: {CONTACT_INFO.email}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Dati raccolti</h2>
              <p>Raccogliamo i seguenti dati personali:</p>
              <ul className="list-disc list-inside space-y-2 mt-4">
                <li>Nome e cognome</li>
                <li>Numero di telefono</li>
                <li>Indirizzo email (se fornito)</li>
                <li>Informazioni di pagamento (gestite da terze parti sicure)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Finalità del trattamento</h2>
              <p>I tuoi dati vengono trattati per:</p>
              <ul className="list-disc list-inside space-y-2 mt-4">
                <li>Gestire le prenotazioni dei biglietti</li>
                <li>Inviarti comunicazioni relative allo spettacolo</li>
                <li>Elaborare i pagamenti</li>
                <li>Rispondere alle tue richieste di informazioni</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Base giuridica</h2>
              <p>
                Il trattamento dei tuoi dati si basa sul tuo consenso e sulla necessità di 
                eseguire il contratto di vendita dei biglietti. Alcuni trattamenti possono 
                essere necessari per adempiere a obblighi di legge.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Conservazione dei dati</h2>
              <p>
                I tuoi dati personali saranno conservati per il tempo necessario a gestire 
                la prenotazione e per gli eventuali adempimenti fiscali previsti dalla legge 
                (fino a 10 anni dalla data della transazione).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Diritti dell'interessato</h2>
              <p>Hai il diritto di:</p>
              <ul className="list-disc list-inside space-y-2 mt-4">
                <li>Accedere ai tuoi dati personali</li>
                <li>Richiedere la rettifica dei dati inesatti</li>
                <li>Richiedere la cancellazione dei dati</li>
                <li>Opporti al trattamento</li>
                <li>Richiedere la portabilità dei dati</li>
                <li>Revocare il consenso in qualsiasi momento</li>
              </ul>
              <p className="mt-4">
                Per esercitare i tuoi diritti, contattaci a: {CONTACT_INFO.email}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Sicurezza</h2>
              <p>
                Adottiamo misure di sicurezza adeguate per proteggere i tuoi dati personali 
                da accessi non autorizzati, perdita o distruzione. I pagamenti sono gestiti 
                da piattaforme terze sicure (Satispay, PayPal) che applicano i più elevati 
                standard di sicurezza.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Modifiche alla Privacy Policy</h2>
              <p>
                Ci riserviamo il diritto di modificare questa Privacy Policy in qualsiasi momento. 
                Le modifiche saranno pubblicate su questa pagina con la data di aggiornamento.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mt-8 mb-4">9. Contatti</h2>
              <p>
                Per qualsiasi domanda relativa a questa Privacy Policy, contattaci:
              </p>
              <ul className="list-none space-y-2 mt-4">
                <li>Email: {CONTACT_INFO.email}</li>
                <li>WhatsApp: {CONTACT_INFO.whatsappDisplay}</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
